import { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { links } from '../../platform/links';
import { biometrics } from '../../platform/biometrics';
export default function IncomingLinks({ children = null }) {
    const [ready, setReady] = useState(false);
    const navigate = useNavigate();
    const location = useLocation();
    const [target, setTarget] = useState(null);
    const current = location.pathname + location.search;
    useEffect(() => { if (target === current) setTarget(null); }, [target, current]);
    useEffect(() => links.onIncomingLink(route => {
        // Recovery/setup must not be replaced by an automatic biometric login.
        if (route !== '/login') biometrics.suppressAutomaticLogin();
        setTarget(route);
        navigate(route, { replace: true });
    }, () => setReady(true)), [navigate]);
    return ready && (!target || target === current) ? children : null;
}
